import React from "react";
import { Route, Redirect } from "react-router-dom";
import LocalStorage from "../hook/LocalStorage";

export const ProtectedRoute = ({ component: Component, hasAccess, ...rest }) => {
  const { access_token, user } = LocalStorage();

  let expired = true;

  if (user) {
    if(user.membership){
      let expireAt = new Date(user.membership.expire_at);
      let currentDate = new Date();
    
      let hours = Math.round(expireAt - currentDate) / 36e5;
  
      if (hours > 0) {
        expired = false;
      }
      else{
        expired = true
      }
    }
    else{
      expired = true
    }
  }


  return (
    <Route
      {...rest}
      render={(props) => {
        if (access_token && user.expire === 1 && !expired) {
          if (hasAccess && !hasAccess(user)) {
            return <Redirect to="/dashboard" />;
          }

          return <Component {...props} />;
        }
        else if (access_token && user.expire === 1 && expired) {
          return (
            <Redirect
              to={{
                pathname: "/event/type",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
        else if (access_token && user.expire === 0 && expired) {
          return (
            <Redirect
              to={{
                pathname: "/event/type",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
        else {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};
